// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_mAu","cls2":"ConfirmationModal-cls2_ZNC ConfirmationModal-cls1_mAu"};